import { uploadImage } from '../modules/portal-remote/portalImageService'
import {
  ADD_CONTRIBUTOR_IMAGE,
  UPDATE_CONTRIBUTOR_IMAGE,
  ADD_CONTRIBUTOR_IMAGE_ERROR,
  UPDATE_CONTRIBUTOR_IMAGE_ERROR,
  SET_CONTRIBUTOR,
} from '../constants/actions'

export const setContributor = contributor => {
  return { type: SET_CONTRIBUTOR, contributor }
}

export const addContributorImage = imageFile => async dispatch => {
  try {
    const {
      ref: mainImageId,
      lastChecked: mainImageLastChecked,
    } = await uploadImage(imageFile)
    dispatch({ type: ADD_CONTRIBUTOR_IMAGE, mainImageId, mainImageLastChecked })
  } catch ({ message }) {
    dispatch({ type: ADD_CONTRIBUTOR_IMAGE_ERROR, message })
  }
}

export const updateContributorImage = (
  imageFile,
  repalceImageID,
  originalImageID,
) => async dispatch => {
  try {
    const {
      ref: mainImageId,
      lastChecked: mainImageLastChecked,
    } = await uploadImage(imageFile, repalceImageID, originalImageID)
    dispatch({
      type: UPDATE_CONTRIBUTOR_IMAGE,
      mainImageId,
      mainImageLastChecked,
    })
  } catch ({ message }) {
    dispatch({ type: UPDATE_CONTRIBUTOR_IMAGE_ERROR, message })
  }
}



// WEBPACK FOOTER //
// ./src/actions/contributor.js